import { getValue } from "@utils/lodash";
import React, { createContext, useContext, useState, useEffect } from "react";

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [clientNavigation, setClientNavigation] = useState([]);
  const [adminNavigation, setAdminNavigation] = useState([]);
  const [clientMoreNavigation, setClientMoreNavigation] = useState([]);
  const [dynamicNavigation, setDynamicNavigation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenFirstLevel, setIsOpenFirstLevel] = useState(null);
  const [isOpenSecondLevel, setIsOpenSecondLevel] = useState(null);
  const [selectedDynamicTab, setSelectedDynamicTab] = useState({});
  const [selectedDynamicTabKey, setSelectedDynamicTabKey] = useState("");
  useEffect(() => {
    if (getValue(localStorage, `d_key`, "")) {
      setSelectedDynamicTabKey(getValue(localStorage, `d_key`, ""));
    }
  }, [getValue(localStorage, `d_key`, "")]);
  const toggleFirstLevel = (index) => {
    setIsOpenFirstLevel(index);
  };
  const toggleSecondLevel = (index, level1) => {
    setIsOpenSecondLevel(index);
  };

  return (
    <NavigationContext.Provider
      value={{
        clientNavigation,
        setClientNavigation,
        clientMoreNavigation,
        setClientMoreNavigation,
        selectedDynamicTab,
        setSelectedDynamicTab,
        selectedDynamicTabKey,
        setSelectedDynamicTabKey,
        adminNavigation,
        setAdminNavigation,
        isLoading,
        setIsLoading,
        isOpenFirstLevel,
        isOpenSecondLevel,
        toggleFirstLevel,
        toggleSecondLevel,
        setIsOpenFirstLevel,
        setIsOpenSecondLevel,
        dynamicNavigation,
        setDynamicNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  return useContext(NavigationContext);
}
